import type { BaseQLFieldDefinition } from '@adornis/baseql/metadata/types.js';
import type { AdornisContext } from '@adornis/baseql/server/context.js';
import { baseConfig } from '@adornis/config/baseConfig.js';

type ResolverGuardOptions = {
  src: object;
  args: Record<string, any>;
  context: AdornisContext;
  info: any; // GraphQLResolveInfo;
  field: BaseQLFieldDefinition;
  next: () => Promise<any>;
};

export const onlyDevGuard = (options: ResolverGuardOptions) => {
  if (baseConfig.get('DEPLOYMENT') !== 'development') {
    throw new Error('This operation is only allowed in development');
  }
  return options.next();
};

export const onlyDevAndQaGuard = (options: ResolverGuardOptions) => {
  if (baseConfig.get('DEPLOYMENT') !== 'development' && baseConfig.get('DEPLOYMENT') !== 'qa') {
    throw new Error('This operation is only allowed in development or qa');
  }
  return options.next();
};
